// extracted by mini-css-extract-plugin
module.exports = {"popup":"popup_popup__35WIx","popup__scroll":"popup_popup__scroll__3BPJB","popup__content":"popup_popup__content__3COAc","popup__close":"popup_popup__close__Ine1h"};